var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "record-fees loading-content-container" },
    [
      _vm.feesListLoading > 0
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.feesListLoading === 0
        ? _c(
            "b-row",
            { staticClass: "mb-4" },
            [
              _c(
                "csp-desktop-info-card",
                {
                  attrs: {
                    cols: 12,
                    icon: "inticon-users",
                    title: "Kostennote",
                  },
                },
                [
                  _vm.permissions.canCreateFee && _vm.createModalAvailable
                    ? _c("csp-record-detail-fee-create-modal", {
                        attrs: {
                          "form-context": _vm.creationFormContext,
                          "record-id": _vm.recordId,
                        },
                        on: {
                          created: function ($event) {
                            _vm.loadFees()
                            _vm.resetCreateModal()
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.editModalFeeId
                    ? _c("csp-record-detail-fee-edit-modal", {
                        attrs: {
                          "fee-id": _vm.editModalFeeId,
                          "form-context": _vm.editFormContext,
                          "is-modal-open": _vm.shouldShowFeeEditModal,
                          "record-id": _vm.recordId,
                        },
                        on: {
                          close: _vm.resetEditModal,
                          updated: _vm.loadFees,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("csp-record-detail-fee-detail-modal", {
                    attrs: {
                      "fee-id": _vm.detailModalFeeId,
                      "is-modal-open": _vm.shouldShowFeeDetailModal,
                      "record-id": _vm.recordId,
                    },
                    on: { close: _vm.resetDetailModal, updated: _vm.loadFees },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "fee-list-table" },
                    [
                      _c("csp-record-detail-fees-list", {
                        attrs: { fees: _vm.fees },
                        on: {
                          "fee-delete": _vm.deleteFee,
                          "fee-details": _vm.showFeeDetails,
                          "fee-edit": _vm.showFeeEdit,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.fees.length
                    ? _c(
                        "div",
                        { staticClass: "fee-legends collapse-body mt-5" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "legends col-md-4" }, [
                              _c("div", { staticClass: "legend" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-2 text-right" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "legend-symbol legend-adjustment",
                                        },
                                        [_vm._v("*")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-10" }, [
                                    _c("p", [
                                      _vm._v(
                                        "Betrag beinhaltet Teil- / Gutschrift"
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-8" },
                              [
                                _c("csp-record-detail-fees-summary", {
                                  attrs: { "fee-summary": _vm.feeSums },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }